import styled from "@emotion/styled";
import Image from "next/image";

const ImpactShopHeroContainer = styled.section`
  position: relative;
  margin: 24px;
  border-radius: 20px;
  overflow: hidden;

  @media ${({ theme }) => theme.bp.desktopUp} {
    margin: 0px 24px 32px 24px;
  }
`;

const BackgroundImage = styled(Image)`
  object-fit: cover;
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 32px 24px;
  gap: 8px;

  @media ${({ theme }) => theme.bp.desktopUp} {
    padding: 32px 56px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

const HeroTitle = styled.h1`
  font-family: ${({ theme }) => theme.typography.fontStack};
  font-size: 28px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.snowdrop};
  margin: 0;

  @media ${({ theme }) => theme.bp.desktopUp} {
    font-size: 40px;
  }
`;

const HeroSubtitle = styled.p`
  font-family: ${({ theme }) => theme.typography.fontStack};
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.snowdrop};
  max-width: 400px;
  margin: 0;
  margin-top: 16px;

  @media ${({ theme }) => theme.bp.desktopUp} {
    font-size: 16px;
    text-align: right;
  }
`;

export const ImpactShopHero = () => {
  return (
    <ImpactShopHeroContainer>
      <BackgroundImage
        src="/images/app/impact-shop/hero-background.jpg"
        alt="Forest with sunlight shining against the trees, viewed from above"
        fill
        priority
      />
      <Content>
        <HeroTitle>Impact shop</HeroTitle>
        <HeroSubtitle>
          Fund diverse, best-in-class projects & impact funds to address the
          climate crisis and restore nature
        </HeroSubtitle>
      </Content>
    </ImpactShopHeroContainer>
  );
};
